const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAzQzIxLjEgMyAyMiAzLjkgMjIgNVYxM0gyMFY5LjZMMTEgMTQuMUwyIDkuNlYxN0gxNlYxOUgyQzAuOSAxOSAwIDE4LjEgMCAxN1Y1QzAgMy45IDAuOSAzIDIgM0gyMFpNMjAgNUgyVjcuNEwxMSAxMS45TDIwIDcuNFY1WiIvPgo8cGF0aCBkPSJNMjIgMTVWMTdIMjRWMTlIMjJWMjFIMjBWMTlIMThWMTdIMjBWMTVIMjJaIi8+Cjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=add_email-1d4b3d09.mjs.map
